module.exports = __webpack_public_path__ + "img/andco logo copy 2.ece7b021.png";